var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNameIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 489,
    height: 321,
    viewBox: "0 0 489 321",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67 0C29.9968 0 0 29.9961 0 67V254C0 291.004 29.9968 321 67 321H422C459.003 321 489 291.004 489 254V67C489 29.9961 459.003 0 422 0H67ZM209 108C209 137.824 184.823 162 155 162C125.177 162 101 137.824 101 108C101 78.1758 125.177 54 155 54C184.823 54 209 78.1758 209 108ZM155.5 183C58.8477 183 47 221.057 47 268H264C264 221.057 243.921 183 155.5 183ZM338.5 226C329.94 226 323 232.939 323 241.5C323 250.061 329.94 257 338.5 257H425.5C434.06 257 441 250.061 441 241.5C441 232.939 434.06 226 425.5 226H338.5ZM288 167.5C288 158.939 294.94 152 303.5 152H425.5C434.06 152 441 158.939 441 167.5C441 176.061 434.06 183 425.5 183H303.5C294.94 183 288 176.061 288 167.5ZM262.5 58C253.94 58 247 64.9395 247 73.5C247 82.0605 253.94 89 262.5 89H425.5C434.06 89 441 82.0605 441 73.5C441 64.9395 434.06 58 425.5 58H262.5Z",
    fill: "#E4E7EA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNameIcon);
export default __webpack_public_path__ + "static/media/name-icon.84f43bcdf226b5b202effabcc3e781b0.svg";
export { ForwardRef as ReactComponent };